/*!
 * egt.preview.people — readable preview for egt.people.group values.
 * [{ name, title, email, phone }] -> one line per person: "Jordan Avery, CFO · jordan@x.com · +1 (614) 555-0100"
 */
var _ = require("../../uam/module.js")(module.exports, {
  namespace: "egt.preview.people",
  title: "Control Preview: People Group",
  description: "Read-only preview for egt.people.group values.",
  fields: {
    value: { title: "Value", type: "*", description: "Array of people (or JSON string)." }
  }
});

var helper = require("../../uat/src/elements/helpers/control.preview.js");

function parse(value) {
  if (typeof value === "string") {
    try { value = JSON.parse(value); } catch (error) { return []; }
  }
  return value instanceof Array ? value : [];
}

function toLines(options) {
  var lines = parse(options.value).map(function (p) {
    p = p || {};
    var who = [p.name, p.title].filter(function (x) { return !!(x || "").toString().trim(); }).join(", ");
    var reach = [p.email, p.phone ? helper.normalizePhone(p.phone) : ""].filter(function (x) { return !!(x || "").toString().trim(); });
    return [who].concat(reach).filter(Boolean).join(" · ");
  });
  return lines;
}

exports.render = async function (options) {
  return helper.renderDoc(helper.jsonLines(toLines(options), "ua-control-preview-lines"));
};

/* Plain-text twin of render() for non-DOM surfaces (emails, logs, exports):
 * the same readable value, as a string. "" means nothing to show. */
exports.toText = function (options) {
  // ", " not " \u00b7 ": outgoing mail is folded to ASCII, which turns "\u00b7" into "*".
  return toLines(options || {}).filter(Boolean).join("\n").replace(/ \u00b7 /g, ", ");
};
